import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import MyHead from '../../components/MyHead';
import Image from 'next/future/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { buttonVariants } from '@/components/v2/UI/Button';
import Link from 'next/link';
import LinkTo from '@/components/LinkTo';

const SecondlifePage: React.FC = () => {
  const { t } = useTranslation();

  const galleryPics = useMemo(
    () => [
      {
        src: '/v2/secondlife/gallery/ga1.jpg'
      },
      {
        src: '/v2/secondlife/gallery/ga2.jpg'
      }
    ],
    []
  );
  const cardsOne = useMemo(
    () => [
      {
        title: t('P_SECONDLIFE.CARDS.CARD-1.TITLE'),
        description: t('P_SECONDLIFE.CARDS.CARD-1.DESC'),
        icosrc: '/v2/sustainability/icon-airnest.png',
        link: '/airnest',
        btntext: t('P_SECONDLIFE.CARDS.CARD-1.BTN'),
        src: '/v2/secondlife/box-airnest.jpg'
      },
      {
        title: t('P_SECONDLIFE.CARDS.CARD-2.TITLE'),
        description: t('P_SECONDLIFE.CARDS.CARD-2.DESC'),
        icosrc: '/v2/sustainability/icon-biomaterials.png',
        link: '/materials',
        btntext: t('P_SECONDLIFE.CARDS.CARD-2.BTN'),
        src: '/v2/airnest/box-biomaterials.jpg'
      }
    ],
    []
  );

  return (
    <div>
      <MyHead />

      <div className="section relative full bg-[#F3F1EB]">
        <div className="section-wrapper relative ">
          <div className="grid gap-8 grid-cols-12 md:gap-12 xl:gap-20">
            <div className="md:col-span-6 col-span-12">
              <div className="lead-1">{t('P_SECONDLIFE.SECTION-1.TITLE')}</div>
              <div className=" tracking-uyn uppercase md:text-3xl opacity-80 mt-4">
                {t('P_SECONDLIFE.SECTION-1.DESC')}
              </div>
            </div>
            <div className="md:col-span-3 self-end md:col-start-8 col-span-6 col-start-4">
              <Image
                src="/v2/secondlife/second-life-icon.png"
                alt=""
                width={0}
                height={0}
                priority
                sizes="100vw"
                className="w-full"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="section relative full bg-[#F3F1EB]">
        <div className="section-wrapper relative ">
          <div className="grid gap-8 grid-cols-12 md:gap-12 xl:gap-20">
            <div className="md:col-span-5 col-span-12 self-center">
              <div className="h3">{t('P_SECONDLIFE.SECTION-2.TITLE')}</div>
              <div className="tracking-uyn md:text-xl opacity-80 mt-6">
                {t('P_SECONDLIFE.SECTION-2.LINE-1')}
              </div>
              <div className="tracking-uyn md:text-xl opacity-80 mt-3">
                {t('P_SECONDLIFE.SECTION-2.LINE-2')}
              </div>
            </div>
            <div className="md:col-span-7 col-span-12">
              <Image
                src="/v2/secondlife/second-1.jpg"
                alt=""
                width={0}
                height={0}
                sizes="100vw"
                className="w-full"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="section relative full bg-gray-900 text-white overflow-hidden aspect-banner">
        <Image
          src="/v2/secondlife/second-2.jpg"
          alt=""
          width={0}
          height={0}
          sizes="100vw"
          className="absolute w-full h-full object-cover object-center top-0 left-0 z-10"
        />

        <div className="absolute w-full h-full bg-black/30 z-20 top-0 left-0"></div>

        <div className="section-wrapper relative z-30 flex flex-col justify-center items-center h-full">
          <div className="text-center">
            <div className="h3">{t('P_SECONDLIFE.SECTION-3.TITLE')}</div>
            <div className="text-body">{t('P_SECONDLIFE.SECTION-3.DESC')}</div>
          </div>
        </div>
      </div>

      <div className="section relative full bg-[#F3F1EB]">
        <div className="section-wrapper relative ">
          <div className="grid gap-8 grid-cols-12 md:gap-12 xl:gap-20">
            <div className="md:col-span-7 col-span-12">
              <Image
                src="/v2/secondlife/second-3.jpg"
                alt=""
                width={0}
                height={0}
                sizes="100vw"
                className="w-full"
              />
            </div>
            <div className="md:col-span-5 col-span-12 self-center">
              <div className="tracking-uyn md:text-xl opacity-80">
                {t('P_SECONDLIFE.SECTION-4.LINE-1')}
              </div>
              <div className="tracking-uyn md:text-xl opacity-80 mt-3">
                {t('P_SECONDLIFE.SECTION-4.LINE-2')}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section relative full bg-[#F3F1EB]">
        <div className="section-wrapper relative ">
          <div className="grid gap-8 grid-cols-12 md:gap-12 xl:gap-20">
            <div className="md:col-span-5 col-span-12 self-center">
              <div className="h3">{t('P_SECONDLIFE.SECTION-4-2.TITLE')}</div>

              <div className="h5 mt-6">
                {t('P_SECONDLIFE.SECTION-4-2.LINE-1')}
              </div>
              <div className="tracking-uyn md:text-xl opacity-80 mt-3">
                {t('P_SECONDLIFE.SECTION-4-2.LINE-2')}
              </div>
            </div>
            <div className="md:col-span-7 col-span-12">
              <Image
                src="/v2/secondlife/second-4.jpg"
                alt=""
                width={0}
                height={0}
                sizes="100vw"
                className="w-full"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="section relative full no-space bg-[#F3F1EB]">
        <Image
          src="/v2/secondlife/second-5.jpg"
          alt=""
          width={0}
          height={0}
          sizes="100vw"
          className="w-full"
        />
      </div>
      <div className="section relative full bg-[#BBAE9F] text-white">
        <div className="section-wrapper relative text-center space-y-10">
          <div className="h3">{t('P_SECONDLIFE.SECTION-5.TITLE')}</div>
          <Image
            src="/v2/secondlife/second-life-product.gif"
            alt=""
            width={0}
            height={0}
            sizes="100vw"
            className="w-full max-w-[1080px] mx-auto"
          />
        </div>
      </div>

      <div className="section relative full bg-[#F3F1EB]">
        <div className="section-wrapper relative ">
          <div className="grid gap-8 grid-cols-12 md:gap-12 xl:gap-20">
            <div className="md:col-span-6 col-span-12">
              <Image
                src="/v2/secondlife/bag.jpg"
                alt=""
                width={0}
                height={0}
                sizes="100vw"
                className="w-full"
              />
            </div>
            <div className="md:col-span-6 col-span-12">
              <div className="h3">{t('P_SECONDLIFE.SECTION-6.TITLE')}</div>
              <div className="tracking-uyn md:text-xl opacity-80 mt-3">
                {t('P_SECONDLIFE.SECTION-6.DESC')}
              </div>
              <div className="flex gap-2 flex-wrap mt-6">
                <Link href="/sku/G100206">
                  <a className={buttonVariants({ variant: 'dark' })}>
                    {t('P_SECONDLIFE.SECTION-6.BTN')}
                  </a>
                </Link>
              </div>

              <div className="relative mt-10">
                <Swiper
                  wrapperTag="ul"
                  slidesPerView={1.2}
                  spaceBetween={16}
                  className=""
                  breakpoints={{
                    768: {
                      slidesPerView: 2.2
                    },
                    1024: {
                      slidesPerView: 1.5
                    }
                  }}
                >
                  {galleryPics.map((card, idx) => (
                    <SwiperSlide key={idx} tag="li" className="rounded-uyn">
                      <Image
                        src={card.src}
                        alt=""
                        width={0}
                        height={0}
                        sizes="100vw"
                        className="w-full rounded-uyn h-auto"
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section relative full">
        <div className="section-wrapper relative">
          <Swiper
            wrapperTag="ul"
            slidesPerView={1.2}
            spaceBetween={16}
            className=""
            breakpoints={{
              768: {
                slidesPerView: 2.2
              },
              1024: {
                slidesPerView: 2
              }
            }}
          >
            {cardsOne.map((card, idx) => (
              <SwiperSlide
                key={idx}
                tag="li"
                className="group rounded-uyn overflow-hidden relative md:aspect-card aspect-cardSwiper"
              >
                <Image
                  src={card.src}
                  alt=""
                  width={0}
                  height={0}
                  sizes="100vw"
                  className="absolute w-full h-full object-cover object-center"
                />

                <div className="absolute z-10 w-full h-full left-0 top-0 bg-black/40 group-hover:bg-black/50 transition-all"></div>
                <div className="absolute z-20 inset-0 flex flex-col text-white p-6 md:p-8">
                  <Image
                    src={card.icosrc}
                    alt=""
                    width={0}
                    height={0}
                    sizes="100vw"
                    className="w-full max-w-[120px] h-auto"
                  />
                  <div className="mt-[25%]">
                    <h3 className="h4">{card.title}</h3>
                    <p className="text-body">{card.description}</p>
                  </div>
                  <div className="flex gap-2 flex-wrap mt-auto">
                    <LinkTo
                      href={card.link}
                      aria-label={card.btntext}
                      className={buttonVariants({ variant: 'light' })}
                    >
                      {card.btntext}
                    </LinkTo>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default SecondlifePage;
